var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.484,
    height: 55.484
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2003",
    d: "M0 0h55.484v55.484H0z",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 17730"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 237",
    d: "M36.268 27.763h-5.062v18.131h-7.549V27.763h-3.57v-6.389h3.57v-4.149a8.981 8.981 0 01.581-3.278 6.37 6.37 0 012.282-3.029 7.968 7.968 0 014.73-1.328l5.6.042v6.223h-4.066a1.608 1.608 0 00-1.037.332 1.746 1.746 0 00-.539 1.411v3.776h5.725z",
    fill: "#2179ff"
  }))));
}
export default SvgSocialFacebook;